import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {encodePassword} from '@app/utils/helpers';
import {
  loginRequest,
  loginSuccess,
  loginError,
  logoutUser,
  loadUserRequest,
  loadUserSuccess,
  loadUserError,
} from './index';

import {login, loadUser} from './api';

export const sagaActions = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  LOAD_USER: 'LOAD_USER',
};

function getDashboardRedirect(roles) {
  if (roles.includes('OWNER')) {
    return '/';
  }
  if (roles.includes('EXECUTIVE')) {
    return '/reporter';
  }
  return '/invalid';
}

function* loginSaga({payload}) {
  const {values, history} = payload;
  try {
    yield put(loginRequest());
    const result = yield call(login, {
      email: values.email,
      password: encodePassword(values.password),
    });
    if (!result.error) {
      yield put(loginSuccess(result));
      toast.success(result.message);
      const redirectUrl = yield call(getDashboardRedirect, result.user.Roles);
      history.push(redirectUrl);
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(loginError(message));
    } else {
      toast.error(e.error);
      yield put(loginError(e.error));
    }
  }
}

function* logoutSaga() {
  yield put(logoutUser());
}

function* loadUserSaga({payload}) {
  const {token, history} = payload;
  try {
    yield put(loadUserRequest());
    const result = yield call(loadUser, {token});
    if (!result.error) {
      yield put(loadUserSuccess({user: result.data, token}));
      // toast.success(result.message);
      const redirectUrl = yield call(getDashboardRedirect, result.data.Roles);
      history.push(redirectUrl);
    }
  } catch (e) {
    const status = Number(get(e, 'status', '0'));
    if (status === 404) {
      history.push('/user/notfound');
    }
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(loadUserError(message));
    } else {
      toast.error(e.error);
      yield put(loadUserError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(sagaActions.LOGIN, loginSaga);
  yield takeLatest(sagaActions.LOGOUT, logoutSaga);
  yield takeLatest(sagaActions.LOAD_USER, loadUserSaga);
}

export default rootSagas;
